'use client';

import { useMemo } from 'react';

import { useAuth } from '@/permissions/AuthProvider';
import { Permission } from '@/permissions/permission';

/**
 * Whether the current user can reach a player's dashboard: the profile owner, an editor,
 * super admin or support. Client-side twin of `requireDashboardAccess`.
 */
export const useAuthorizeDashboard = (isOwnProfile: boolean): boolean => {
  const { hasPermission } = useAuth();

  return useMemo(() => {
    const isEditor = hasPermission(Permission.USERS_PROFILES_EDITOR);
    const isSuperAdmin = hasPermission(Permission.SUPER_ADMIN);
    const isSupport = hasPermission(Permission.SUPPORT_STAFF);

    return isOwnProfile || isEditor || isSuperAdmin || isSupport;
  }, [hasPermission, isOwnProfile]);
};
